export default "__VITE_ASSET__jL$oJ3Lx__"